let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("grKb4")).then(() => parcelRequire('lXx38'));